import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {useSelector} from 'react-redux';
import ButtonBack from 'components/button/buttonBack';
import MultiSelect from 'components/select/index';
import EmptyState from 'components/commonComponent/emptyState';
import {orgSelector} from 'redux/selectors';
import {routePaths, sortByTypeType} from 'utils/constants';
import {getOrgVendorsByFilter} from 'api/vendorApi';

const itemEmpty = require('../../assets/image/svg/Emptys.svg').default || '';

const PurchaseOrderCreate = () => {
    const [t] = useTranslation();
    const navigate = useNavigate();
    const {organizationId} = useSelector(orgSelector);
    const [vendorTypeOptions, setVendorTypeOptions] = useState<any[]>([]);
    const [isVendorOptionsLoaded, setIsVendorOptionsLoaded] = useState(false);
    const [selectedVendor, setSelectedVendor] = useState<any>(null);

    useEffect(() => {
        getOrgVendorsByFilter({page: 0, limit: 1000, sortByType: sortByTypeType.DESC, organizationId})?.then(res => {
            const newOption = res?.data?.entities?.map((i: any) => ({
                label: i.name,
                value: i.id,
            }));
            setVendorTypeOptions(newOption || []);
            setIsVendorOptionsLoaded(true);
        }).catch(() => {
            setVendorTypeOptions([]);
            setIsVendorOptionsLoaded(true);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [organizationId]);

    useEffect(() => {
        if (!isVendorOptionsLoaded || vendorTypeOptions.length !== 1) return;
        const onlyVendor = vendorTypeOptions[0];
        setSelectedVendor(onlyVendor);
        navigate(`${routePaths.PURCHASE_ORDER_DETAIL}/blank-new?organizationVendorId=${onlyVendor.value}`, {
            state: {autoAddItemRow: true},
        });
    }, [isVendorOptionsLoaded, navigate, vendorTypeOptions]);

    const handleSelectVendor = (option: any) => {
        setSelectedVendor(option || null);
        if (!option?.value) return;
        navigate(`${routePaths.PURCHASE_ORDER_DETAIL}/blank-new?organizationVendorId=${option.value}`, {
            state: {autoAddItemRow: true},
        });
    };

    return (
        <div className="flex flex-col w-full p-[15px]">
            <div className="border-b border-gray-200 pb-4 mb-6">
                <ButtonBack buttonName={t('sidebar.purchaseOrder')} handleBack={() => navigate(-1)}/>
            </div>
            {isVendorOptionsLoaded && vendorTypeOptions?.length === 0 ? (
                <EmptyState
                    icon={itemEmpty}
                    title="This organization has no vendor. Contact site admin."
                    subtitle=""
                />
            ) : (
                <EmptyState
                    icon={itemEmpty}
                    title={t('vendorAssignmentPage.selectVendor')}
                    subtitle="Select vendor to add item."
                    renderAction={
                        <div className="mt-5 w-[280px]">
                            <MultiSelect
                                onChange={handleSelectVendor}
                                options={vendorTypeOptions}
                                value={selectedVendor}
                                isHolderLabel={false}
                                placeholder={t('vendorAssignmentPage.selectVendor')}
                                noOptionsMessage={() => t('No options')}
                            />
                        </div>
                    }
                />
            )}
        </div>
    );
};

export default PurchaseOrderCreate;
